import { Fragment, useEffect, useState } from "react";

import { useTranslation } from "i18n";

import { ReactComponent as CuracaoFlag } from "assets/images/cw.svg";
import { ReactComponent as NetherlandsFlag } from "assets/images/nl.svg";
import { ReactComponent as SurinameFlag } from "assets/images/sr.svg";

import Branch from "./components/branch";
import "./style.css";

const CALL_LINES = [
  {
    country: "suriname",
    Flag: SurinameFlag,
    numbers: [
      { display: "+597436950", tel: "+597436950" },
      { display: "1611", tel: "1611" },
    ],
    joinerKey: "or",
  },
  {
    country: "netherlands",
    Flag: NetherlandsFlag,
    numbers: [{ display: "+31707113625", tel: "+31707113625" }],
  },
  {
    country: "curacao",
    Flag: CuracaoFlag,
    numbers: [
      { display: "+5999 7880134", tel: "+59997880134" },
      { display: "7880139", tel: "+59997880139" },
    ],
    joiner: "/",
  },
];

const BRANCHES = [
  {
    country: "suriname",
    name: "Head Office",
    address:
      "Doebestraat # 3 P.O.Box 5145 Kwatta Paramaribo- Suriname S.a.",
    tel: "1611 or +597 436950",
    whatsapp: "+597436950",
    openeingHours:
      "Monday thru Friday 08:30 - 16:30 \n Saturday : 09.30u-13.00u",
  },
  {
    country: "suriname",
    name: "Branch Office",
    address: "Grote Combeweg # 125 Combe Markt Complex",
    tel: "1611 or +597 436950",
    openeingHours: "Monday thru Friday 08:30 - 16:30",
  },
  {
    country: "suriname",
    name: "Branch Office",
    address: "Bridgemall unit 10-06 Meerzorg nr. 284",
    tel: "1611 or +597 436950",
    openeingHours: "Monday thru Friday 09:00 - 17:00",
  },
  {
    country: "suriname",
    name: "Branch Office",
    address:
      "MidTown Mall Unit 10\nSuriname, Paramaribo\nIndira Gandhiweg 510, Lelydorp",
    tel: "1611 or +597 436950",
    openeingHours: "Monday thru Friday 08:30 - 16:30",
  },
  {
    country: "suriname",
    name: "Branch Office",
    address: "G.G.Maynardstraat #28, Nieuw Nickerie, Suriname",
    tel: "1611 or +597 436950",
    openeingHours:
      "Monday thru Friday 08:30 - 16:30 \n Saturday : 09:30 - 14:00",
  },
  {
    country: "netherlands",
    name: "Branch Office",
    address: "Loosduinsekade # 414, 2571 CJ Den Haag",
    tel: "070-7113625 (4 lijnen)",
    whatsapp: "+31707113625",
    openeingHours:
      "Monday thru Friday 09:30 - 16:30 \n Saturday : 10:00 - 14:00",
  },
  {
    country: "india",
    name: "Branch Office",
    address:
      "B – 63 / 2, Basement, Paryavaran Complex IGNOU Road (Near Saket metro station) New Delhi - 110030",
    tel: "+91 - 11 – 29535690 / 29535691",
    openeingHours: "Monday thru Saturday 10:00 - 19:00",
  },
  {
    country: "curacao",
    name: "Branch Office",
    address: "Mangusa Hypermarket Cas Cora Weg # 43 Unit # 4",
    tel: "+5999 7880134 / 7880139",
    whatsapp: "+59995141040",
    openeingHours:
      "Monday - Friday : 8:30am-12:30am, 13.30pm-16.30pm \n Saturday : 9:00am - 12:30am",
  },
];

const WHATSAPP_OPTIONS = [
  {
    country: "suriname",
    digits: "597436950",
    display: "+597 436950",
  },
  {
    country: "netherlands",
    digits: "31707113625",
    display: "+31 70 711 3625",
  },
  {
    country: "curacao",
    digits: "59995141040",
    display: "+5999 514 1040",
  },
];

const CallRow = ({ country, Flag, numbers, joiner, joinerKey }) => {
  const { t } = useTranslation();
  const isSingle = numbers.length === 1;
  const separator =
    joiner || (joinerKey === "or" ? t("contact.quickContact.callOr") : null);

  return (
    <div className={`contact-call__row${isSingle ? "" : " contact-call__row--multi"}`}>
      <span className="contact-flag" aria-hidden="true">
        <Flag />
      </span>
      <div className="contact-call__copy">
        <span className="contact-call__country">
          {t(`contact.branches.countries.${country}`)}
        </span>
        <div className="contact-call__numbers">
          {numbers.map((number, index) => (
            <Fragment key={number.tel}>
              {index > 0 && separator && (
                <span className="contact-call__join">{separator}</span>
              )}
              <a href={`tel:${number.tel}`}>{number.display}</a>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

const ContactUs = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [whatsappPickerOpen, setWhatsappPickerOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!whatsappPickerOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") setWhatsappPickerOpen(false);
    };
    document.addEventListener("keydown", onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [whatsappPickerOpen]);

  const handleField = (field) => (event) =>
    setForm((state) => ({ ...state, [field]: event.target.value }));

  const handleSubmit = (event) => {
    event.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setSuccess(true);
    }, 800);
  };

  const handleReset = () => {
    setForm({ name: "", email: "", subject: "", message: "" });
    setSuccess(false);
  };

  const emailValue = t("contact.quickContact.emailValue");
  const totalBranches = BRANCHES.length;
  const totalCountries = new Set(BRANCHES.map((branch) => branch.country)).size;

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero__glow" aria-hidden="true" />
        <div className="container contact-hero__content">
          <p className="contact-hero__eyebrow">{t("contact.eyebrow")}</p>
          <h1 className="contact-hero__title">{t("contact.heading")}</h1>
          <p className="contact-hero__subtitle">{t("contact.subtitle")}</p>
        </div>
      </section>

      <div className="container contact-shell">
        <section className="contact-reach" aria-label={t("contact.getInTouch")}>
          <div className="contact-reach__block">
            <p className="contact-reach__label">
              {t("contact.quickContact.callLabel")}
            </p>
            <div className="contact-call">
              {CALL_LINES.map((line) => (
                <CallRow
                  key={line.country}
                  country={line.country}
                  Flag={line.Flag}
                  numbers={line.numbers}
                  joiner={line.joiner}
                  joinerKey={line.joinerKey}
                />
              ))}
            </div>
          </div>

          <div className="contact-reach__block">
            <p className="contact-reach__label">
              {t("contact.quickContact.emailLabel")}
            </p>
            <a className="contact-reach__link" href={`mailto:${emailValue}`}>
              <span className="contact-reach__copy">
                <span className="contact-reach__hint">
                  {t("contact.quickContact.emailAction")}
                </span>
                <span className="contact-reach__value">{emailValue}</span>
              </span>
            </a>
          </div>

          <div className="contact-reach__block">
            <p className="contact-reach__label">
              {t("contact.quickContact.whatsappLabel")}
            </p>
            <button
              type="button"
              className="contact-reach__action"
              onClick={() => setWhatsappPickerOpen(true)}
            >
              <span className="contact-reach__copy">
                <span className="contact-reach__hint">
                  {t("contact.quickContact.whatsappAction")}
                </span>
                <span className="contact-reach__value">
                  {t("contact.quickContact.whatsappValue")}
                </span>
              </span>
            </button>
          </div>
        </section>

        <section className="contact-board">
          <div className="contact-form">
            <p className="contact-kicker">{t("contact.form.eyebrow")}</p>
            <h2>{t("contact.form.title")}</h2>
            <p>{t("contact.form.subtitle")}</p>

            {success ? (
              <div className="contact-success">
                <h3>{t("contact.form.successTitle")}</h3>
                <p>{t("contact.form.successMessage")}</p>
                <button
                  type="button"
                  className="contact-reset"
                  onClick={handleReset}
                >
                  {t("contact.form.sendAnother")}
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} noValidate autoComplete="off">
                <div className="contact-fields">
                  <div className="contact-field">
                    <label htmlFor="contact-name">{t("contact.form.name")}</label>
                    <input
                      id="contact-name"
                      required
                      value={form.name}
                      onChange={handleField("name")}
                      placeholder={t("contact.form.namePlaceholder")}
                    />
                  </div>
                  <div className="contact-field">
                    <label htmlFor="contact-email">{t("contact.form.email")}</label>
                    <input
                      id="contact-email"
                      required
                      type="email"
                      value={form.email}
                      onChange={handleField("email")}
                      placeholder={t("contact.form.emailPlaceholder")}
                    />
                  </div>
                  <div className="contact-field contact-field--full">
                    <label htmlFor="contact-subject">
                      {t("contact.form.subject")}
                    </label>
                    <input
                      id="contact-subject"
                      value={form.subject}
                      onChange={handleField("subject")}
                      placeholder={t("contact.form.subjectPlaceholder")}
                    />
                  </div>
                  <div className="contact-field contact-field--full">
                    <label htmlFor="contact-message">
                      {t("contact.form.message")}
                    </label>
                    <textarea
                      id="contact-message"
                      required
                      value={form.message}
                      onChange={handleField("message")}
                      placeholder={t("contact.form.messagePlaceholder")}
                    />
                  </div>
                  <div className="contact-field contact-field--full">
                    <button
                      type="submit"
                      className="contact-submit"
                      disabled={submitting}
                    >
                      {submitting
                        ? t("contact.form.sending")
                        : t("contact.form.submit")}
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>

          <aside className="contact-visit">
            <div className="contact-visit__map">
              <iframe
                title="Satyam Holidays — Head Office, Paramaribo"
                src="https://www.openstreetmap.org/export/embed.html?bbox=-55.2230%2C5.8420%2C-55.1880%2C5.8620&layer=mapnik&marker=5.8520%2C-55.2038"
                loading="lazy"
              />
            </div>
            <div className="contact-visit__body">
              <p className="contact-kicker">{t("contact.visitUs.eyebrow")}</p>
              <h2>{t("contact.visitUs.title")}</h2>
              <p>{t("contact.visitUs.address")}</p>
              <p className="contact-visit__hours">{t("contact.visitUs.hours")}</p>
              <a
                className="contact-visit__link"
                href="https://www.openstreetmap.org/?mlat=5.8520&mlon=-55.2038#map=17/5.8520/-55.2038"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("contact.visitUs.directions")}
              </a>
            </div>
          </aside>
        </section>

        <section className="contact-offices">
          <div className="contact-offices__head">
            <div>
              <p className="contact-kicker">{t("contact.branches.eyebrow")}</p>
              <h2>{t("contact.branches.title")}</h2>
            </div>
            <p className="contact-offices__meta">
              {t("contact.branches.officesMeta", {
                offices: totalBranches,
                countries: totalCountries,
              })}
            </p>
          </div>
          <div className="contact-offices__grid">
            {BRANCHES.map((branch, index) => (
              <Branch key={`${branch.country}-${index}`} branch={branch} />
            ))}
          </div>
        </section>
      </div>

      {whatsappPickerOpen && (
        <div
          className="contact-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="whatsapp-picker-title"
        >
          <button
            type="button"
            className="contact-modal__backdrop"
            aria-label="Close"
            onClick={() => setWhatsappPickerOpen(false)}
          />
          <div className="contact-modal__card">
            <div className="contact-modal__head">
              <div>
                <p className="contact-kicker">
                  {t("contact.quickContact.whatsappLabel")}
                </p>
                <h2 id="whatsapp-picker-title">
                  {t("contact.whatsappPicker.title")}
                </h2>
                <p>{t("contact.whatsappPicker.subtitle")}</p>
              </div>
              <button
                type="button"
                className="contact-modal__close"
                aria-label="Close"
                onClick={() => setWhatsappPickerOpen(false)}
              >
                ×
              </button>
            </div>
            <div className="contact-modal__list">
              {WHATSAPP_OPTIONS.map((option) => (
                <a
                  key={option.country}
                  href={`https://wa.me/${option.digits}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setWhatsappPickerOpen(false)}
                >
                  <strong>
                    {t(`contact.branches.countries.${option.country}`)}
                  </strong>
                  <span>{option.display}</span>
                </a>
              ))}
            </div>
            <p className="contact-modal__note">
              {t("contact.whatsappPicker.redirectNotice")}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
